module.exports = __webpack_public_path__ + "static/media/Poppins-SemiBold.f51205b1.woff2";